import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';
import { START_UP_COMPLETE, START_UP_ERROR } from 'actions/startup';

const INITIAL_STATE = Immutable({
  loading: true,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case START_UP_COMPLETE:
      return state.merge({
        loading: false,
        error: null,
      });
    case START_UP_ERROR:
      return state.merge({
        loading: false,
        error: true,
      });
    default:
      return state;
  }
};
